import { render, staticRenderFns } from "./viewMessagesDialog.vue?vue&type=template&id=004cf44b&scoped=true"
import script from "./viewMessagesDialog.vue?vue&type=script&lang=ts"
export * from "./viewMessagesDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004cf44b",
  null
  
)

export default component.exports